import { type FormEvent, type ReactNode } from "react";

import { getText } from "shared/lib";

import { Input, Label } from "shared/components";
import { IconSpinner } from "@/components/icons";

interface ResetPasswordProps {
  errorMessage: ReactNode;
  isLoading: boolean;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export function ResetPassword({
  errorMessage,
  isLoading,
  onSubmit,
}: ResetPasswordProps) {
  return (
    <div className="flex flex-col">
      <h1 className="mb-6 text-left text-heading2xl font-semibold">
        {getText("Reset password")}
      </h1>
      <div className="flex">
        <form onSubmit={onSubmit} className="w-full">
          <div className="flex flex-col gap-y-3">
            <div className="flex flex-col gap-1">
              <Label
                className="text-headingsm text-textPrimary"
                htmlFor="password"
              >
                {getText("New password")}
              </Label>
              <Input
                autoCapitalize="none"
                autoComplete="password"
                autoCorrect="off"
                className="border-interactiveBorder bg-interfaceWhite placeholder:text-textSubdued text-textPrimary rounded-lg p-4 text-bodymd"
                disabled={isLoading}
                id="password"
                name="password"
                placeholder={getText("New password")}
                type="password"
              />
            </div>
            <div className="flex flex-col gap-1">
              <Label
                className="text-headingsm text-textPrimary"
                htmlFor="password"
              >
                {getText("Confirm password")}
              </Label>
              <Input
                autoCapitalize="none"
                autoComplete="none"
                autoCorrect="off"
                className="border-interactiveBorder bg-interfaceWhite placeholder:text-textSubdued text-textPrimary rounded-lg p-4 text-bodymd"
                disabled={isLoading}
                id="passwordConfirm"
                name="passwordConfirm"
                placeholder={getText("Confirm new password")}
                type="password"
              />
            </div>
          </div>
          <button
            className="bg-actionDefault text-textWhite mt-4 flex w-full flex-row items-center justify-center rounded-sm px-4 py-2 text-bodylg font-semibold"
            disabled={isLoading}
          >
            {getText("Reset password")}
            {isLoading && <IconSpinner className="ml-1 h-4 w-4 animate-spin" />}
          </button>
          <div
            hidden={errorMessage == ""}
            className="border-destructiveBorder bg-destructiveBgDefault text-destructiveText mt-6 rounded-sm border px-4 py-2 text-center text-bodymd"
          >
            {errorMessage}
          </div>
        </form>
      </div>
    </div>
  );
}
